import PaginationGroup from './PaginationGroup';

// export types
export type { PaginationGroupProps as PaginationProps } from './PaginationGroup';

// export components
export { PaginationGroup as Pagination };
export default PaginationGroup;
